export const Table = {
  Pagination: {
    PAGE: "Сторінка",
    SEPARATOR: "з",
  },
};
